// src/DragHandle.tsx
import {
  defaultComputePositionConfig,
  DragHandlePlugin,
  dragHandlePluginDefaultKey
} from "@tiptap/extension-drag-handle";
import { useEffect, useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
var DragHandle = (props) => {
  const {
    className = "drag-handle",
    children,
    editor,
    pluginKey = dragHandlePluginDefaultKey,
    onNodeChange,
    onElementDragStart,
    onElementDragEnd,
    computePositionConfig = defaultComputePositionConfig
  } = props;
  const [element, setElement] = useState(null);
  const plugin = useRef(null);
  useEffect(() => {
    let initPlugin = null;
    if (!element) {
      return () => {
        plugin.current = null;
      };
    }
    if (editor.isDestroyed) {
      return () => {
        plugin.current = null;
      };
    }
    if (!plugin.current) {
      initPlugin = DragHandlePlugin({
        editor,
        element,
        pluginKey,
        computePositionConfig: {
          ...defaultComputePositionConfig,
          ...computePositionConfig
        },
        onElementDragStart,
        onElementDragEnd,
        onNodeChange
      });
      plugin.current = initPlugin.plugin;
      editor.registerPlugin(plugin.current);
    }
    return () => {
      editor.unregisterPlugin(pluginKey);
      plugin.current = null;
      if (initPlugin) {
        initPlugin.unbind();
        initPlugin = null;
      }
    };
  }, [element, editor, onNodeChange, pluginKey, computePositionConfig, onElementDragStart, onElementDragEnd]);
  return /* @__PURE__ */ jsx("div", { className, style: { visibility: "hidden", position: "absolute" }, ref: setElement, children });
};

// src/index.ts
var index_default = DragHandle;
export {
  DragHandle,
  index_default as default
};
//# sourceMappingURL=index.js.map